define([], function() {
    var _self;
    // console.log('field-address');

    // obj
    _self = {
        create: function ($el) {
            var $address = ($el) ? $el.find('[data-google-address]') : $('[data-google-address]');

            $address.each(function (i) {
                var autocomplete,
                    $input = $(this),
                    $form = $input.closest('.form');

                // Create the autocomplete object, restricting the search to geographical location types.
                autocomplete = new google.maps.places.Autocomplete($address[i], {
                        types: ['address'],
                        componentRestrictions: {country: "au"}
                    }
                );

                $input.on('keydown', function (event) {
                    if (event.which == 13) {
                        if ($('.pac-container:visible').length) {
                            event.preventDefault();
                            return false;
                        }
                    } else {
                        $(this).removeAttr('data-address');
                        $(this).removeData('address');
                    }
                });

                // on change
                google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    var place = autocomplete.getPlace(),
                        fetched_address = {},
                        combined_address = "",
                        street_name = "",
                        street_suffix = "",
                        unit_number = "",
                        street_number = "",
                        street_number_1 = "",
                        street_number_2 = "",
                        newData = {},
                        inputName = $input.data('google-address') || 'address' + 1,
                        lowercase_street_name = '',
                        street_array = '',
                        street_last_word = '',
                        componentForm = {
                            subpremise: 'short_name',
                            street_number: 'short_name',
                            route: 'long_name',
                            locality: 'long_name',
                            administrative_area_level_1: 'short_name',
                            country: 'short_name',
                            postal_code: 'short_name'
                        };

                    if (typeof(place.address_components) !== "undefined") {

                        // remove alert
                        $input.closest('.field').removeClass('field--alert').find('.field__alert').remove();

                        // Get each component of the address from the place details
                        // and fill the corresponding field on the form.

                        for (var i = 0; i < place.address_components.length; i++) {
                            var addressType = place.address_components[i].types[0];
                            if (componentForm[addressType]) {
                                var val = place.address_components[i][componentForm[addressType]];
                                fetched_address[addressType] = val;
                            }
                        }

                        // Split Street Number to Unit Number & Street Number
                        if (typeof(fetched_address.street_number) !== "undefined" ) {
                            street_number = fetched_address.street_number;

                            // append FULL ADDRESS
                            combined_address = fetched_address.street_number;
                        }

                        // Check Street Number if it has '-'
                        if (street_number !== "") {
                            if(street_number.indexOf('-') > -1) {
                                var street_number_res = street_number.split('-');
                                street_number_1 = street_number_res[0];
                                street_number_2 = street_number_res[1];
                            }
                            else {
                                street_number_1 = street_number;
                            }
                        }

                        // Check for suffix in street_name
                        if (typeof(fetched_address.route) !== "undefined") {
                            lowercase_street_name = fetched_address.route.toLowerCase();
                            street_array = lowercase_street_name.split(' ');
                            street_last_word = street_array[street_array.length - 1];

                            // append FULL ADDRESS
                            if (combined_address.length) {
                                combined_address += " ";
                            }
                            combined_address += fetched_address.route;
                        }

                        // new data
                        newData[inputName + '_address'] = combined_address;
                        newData[inputName + '_street_type'] = street_last_word;
                        newData[inputName + '_unit_number'] = fetched_address.subpremise;
                        newData[inputName + '_street_number'] = street_number_1;
                        newData[inputName + '_street_number_2'] = street_number_2;
                        newData[inputName + '_street_name'] = fetched_address.route;
                        newData[inputName + '_suburb'] = fetched_address.locality;
                        newData[inputName + '_postcode'] = fetched_address.postal_code;
                        newData[inputName + '_state'] = fetched_address.administrative_area_level_1;
                        newData[inputName + '_country'] = fetched_address.country;

                        // lazy backend code
                        if (inputName == 'check') {
                            delete newData.check_street_type;
                            newData.street_type = street_last_word;
                        }

                        // console.log('NORMAL data');
                        // console.log(newData);
                        // console.log('PARAM data');
                        // console.log($.param(newData));

                        // append data
                        // $input.data('address', $.param(newData));
                        $input.data('address', newData);

                        $form.trigger('update', $input);
                    }
                    else {
                        // append data
                        // $input.data('address', place.name);
                        console.log('no address data');
                    }
                });
            });
        }
    };


    // -------------------
    // BINDS
    // -------------------

    _self.create();

    return _self;
});
